// extracted by mini-css-extract-plugin
export default {"pageTransition":"_PageTransition_pageTransition__2vkV-","pageContent":"_PageTransition_pageContent__FzDH7"};